/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnterpriseCustomerIdDto } from './enterpriseCustomerIdDto';
import { FieldGeometryDto } from './fieldGeometryDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface FieldV2Dto {
  active?: boolean;
  color?: string;
  comment?: string;
  cropType?: string;
  customer?: EnterpriseCustomerIdDto;
  deleted?: boolean;
  externalId?: string;
  foxCultivationId?: string;
  geometry?: FieldGeometryDto;
  harvestYear?: number;
  id?: number;
  identifier?: string;
  name?: string;
  owner?: EnterpriseIdDto;
  updated?: string;
  validFrom?: string;
  validUntil?: string;
}
